import { useDispatch, useSelector } from "react-redux";
import { cacheApiRequest, postrequest } from "../utils/cacheApiRequest";
import { clearCache, clearAllCacheForBaseKey } from "../store/cacheSlice";

export const useConfigDataService = () => {
  const dispatch = useDispatch();
  const cache = useSelector((state) => state.cache.cache);

  const fetchLocationMaster = async (params = {}, forceRefresh = false) => {
    const key = "CONFIG_GET_LOCATION_MASTER";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const fetchAPISyncStatus = async (params = {}, forceRefresh = false) => {
    const key = "CONFIG_GET_SYNC_STATUS";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const fetchAdminUserList = async (params = {}, forceRefresh = false) => {
    const key = "CONFIG_GET_ADMIN_ACCESS_LIST";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const getProjectLocations = async (params = {}, forceRefresh = false) => {
    const key = "CONFIG_GET_ADMIN_ACCESS_PROJECT_LIST";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const getBusinessVerticals = async (params = {}, forceRefresh = false) => {
    const key = "CONFIG_GET_ADMIN_BUSINESS_VERTICAL_LIST";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const getEmployeeList = async (params = {}, forceRefresh = false) => {
    const key = "CONFIG_GET_ADMIN_ACCESS_LIST";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const syncNow = async (endpoint) => {
    const key = "CONFIG_POST_SYNC_NOW";
    const result = await cacheApiRequest(key, dispatch, cache, {
      params: { Endpoint: endpoint },
    });

    // Optional: refresh the sync status after trigger
    // await fetchAPISyncStatus({}, true);

    return result;
  };

  const saveAdminAccessConfiguration = async (data) => {
    const key = "CONFIG_POST_ADMIN_ACCESS_USERDATA";
    const result = await postrequest(key, dispatch, cache, {
      data, // ✅ pass data in POST body
    });
    return result;
  };

  const getEmployeeListtoAddAdmin = async (
    params = {},
    forceRefresh = false
  ) => {
    const key = "CONFIG_GET_ADMIN_ACCESS_EMP_IDS";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  return {
    fetchLocationMaster,
    fetchAPISyncStatus,
    fetchAdminUserList,
    getProjectLocations,
    getEmployeeList,
    getBusinessVerticals,
    getProjectLocations,
    syncNow,
    getEmployeeListtoAddAdmin,
    saveAdminAccessConfiguration,
  };
};
